import {scrolling} from './modules/scroll';
import {watchScroll} from './modules/watcScroll';
import {scrollToTop} from './modules/scroll-to-top';
import {allBlocksInit} from './modules/blocks';
import {loader} from './modules/loader';
import {cursor} from './modules/cursor';
import {menu} from './modules/menu';
import {popups} from './modules/popups';
import {forms} from './modules/forms';
import {customSelect} from './modules/select';
import {interScrolling} from './modules/intersectScroll';
import barba from '@barba/core';
// import Splitting from 'splitting';
import {accordion} from './modules/accordion';
import {replaceSymbols} from './modules/replace';
// import {addClass} from "./modules/helpers";

window.axios = require('./modules/axios.min');
window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

window.shApp = {
  focusedInput: false,
  homeSlideAutoplay: true,
  pageTop: null,
  requestAnimation: null,
  onLazyImageLoad: (_el) => {
    const _lazy = _el.closest(".sh-lazy");
    if (_lazy) {
      _lazy.querySelector('.sh-lazy__img').style['opacity'] = 0;
      setTimeout(() => {
        _lazy.outerHTML = _el.closest("picture").outerHTML;

        if (typeof window.shApp.resetPrlx === 'function') {
          window.shApp.resetPrlx();
        }
      }, 300);
    }
  },
  onLazyVideoLoad: (_el) => {
    const _lazy = _el.closest(".sh-lazy");
    if (_lazy) {
      _lazy.outerHTML = _el.outerHTML;
    }
  }
};

const app = () => {
  // setTimeout(() => {
  //   Splitting();
  // }, 3000);
  scrolling.init();
  scrollToTop.init();
  window.shApp.scrollTo = scrolling.scrollTo;
  Object.defineProperties(window.shApp, {
    'scrollTop': {
      get: function () {
        return this.pageTop;
      },
      set: function (val) {
        // const newVal = Math.round(val);
        // const oldVal = Math.round(this.pageTop);
        const newVal = parseFloat(val);
        const oldVal = parseFloat(this.pageTop);
        if (newVal !== oldVal || this.pageTop === null) {
          watchScroll(newVal, oldVal);
        }
        this.pageTop = newVal;
      }
    }
  });
  cursor.init();
  menu.init();
  popups.init();
  forms.init();
  customSelect.init();
  allBlocksInit();
  accordion.init();
  replaceSymbols.init();

  window.shApp.scrollTop = 0;
  window.addEventListener('scroll', function () {
    window.shApp.scrollTop = window.scrollY;
  });
  window.addEventListener('keydown', function ({target, keyCode}) {
    const tag = target.tagName.toLowerCase();
    if (['input', 'textarea', 'select'].includes(tag)) return;
    const headerH = document.querySelector('header').getBoundingClientRect().height;
    let newY = 0;
    switch (keyCode) {
      case 32:
        newY = window.innerHeight / 4 * 3;
        break;
      case 38:
        newY = -window.innerHeight / 3;
        break;
      case 40:
        newY = window.innerHeight / 3;
        break;
    }
    if (window.shApp.scrollTop !== newY) {
      window.shApp.scrollTo(newY + headerH);
    }
  });

  interScrolling.init();

  loader();

  let barbaJS = barba;
  barbaJS.init({
    schema: {
      prefix: 'data-lazy'
    },
    requestError: (trigger, action, url, response) => {
      // go to a custom 404 page if the user click on a link that return a 404 response status

      // console.log(url, response.status, response);
      if (action === 'click' && response.status && response.status === 404) {
        barbaJS.go('/404');
      }
      if (action === 'click' && response.status === undefined) {
        setTimeout(() => {
          barbaJS.force(url);
        }, 50);
      }

      // prevent Barba from redirecting the user to the requested URL
      // this is equivalent to e.preventDefault()
      return false;
    },
    preventRunning: false,
    prefetchIgnore: true,

    transitions: [{
      name: 'opacity-transition',
      leave(data) {

      },
      enter() {

      }
    }]
  });
  barbaJS.hooks.beforeLeave((data) => {
    scrolling.scrollTo(-window.shApp.scrollTop);
    scrolling.destroy();
    interScrolling.destroy();
  });
  barbaJS.hooks.after((data) => {
    const html = document.createElement( 'html' );
    html.innerHTML = data.next.html;
    document.querySelector('#app').className = '';
    document.querySelector('header').innerHTML = html.querySelector('header').innerHTML;
    document.querySelector('#app').dataset['page'] = html.querySelector('#app').dataset['page'];

    cancelAnimationFrame(window.shApp.requestAnimation);
    scrolling.init(document.querySelector('#scroller'));
    window.shApp.scrollTo = scrolling.scrollTo;
    menu.closeAll();
    allBlocksInit();
    interScrolling.init();
    accordion.init();
    replaceSymbols.init();
    window.shApp.selects.reInit();
    setTimeout(() => {
      watchScroll(0, 0);
    }, 50);
  })

  window.shApp.barba = barbaJS;
};

document.addEventListener('DOMContentLoaded', app);


